import { Skeleton } from "primereact/skeleton";

const PathDetailsSkeleton = () => {
  return (
    <div className="pb-8">
      <div className="flex items-center justify-between gap-8 mb-8">
        <div className="flex items-center gap-4">
          <Skeleton width="60px" height="24px" className="rounded-full" />
          <Skeleton width="80px" height="24px" className="rounded-full" />
          <Skeleton width="90px" height="24px" className="rounded-full" />
        </div>
        <div className="flex gap-4 flex-wrap">
          <Skeleton width="130px" height="40px" className="rounded" />
          <Skeleton width="95px" height="40px" className="rounded" />
          <Skeleton width="100px" height="40px" className="rounded" />
          <Skeleton width="120px" height="40px" className="rounded" />
          <Skeleton width="90px" height="40px" className="rounded" />
        </div>
      </div>
      <div className="flex mb-8">
        <div className="flex flex-col gap-4 max-w-xl">
          <Skeleton width="300px" height="32px" />
          <Skeleton width="500px" height="20px" />
          <Skeleton width="450px" height="20px" />
          <Skeleton width="400px" height="20px" />
        </div>
        <Skeleton width="80px" height="80px" className="rounded-full" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-6">
        {[...Array(4)].map((_, i) => (
          <div key={i}>
            <Skeleton width="100px" height="16px" className="mb-2" />
            <Skeleton width="60px" height="28px" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PathDetailsSkeleton;
